module.exports = __webpack_public_path__ + "static/media/banner-beneficios.7c28d43e.jpeg";